import {
    SET_SBTP_UPDATE_STATE
} from 'constants/ActionTypes';

export const setSBTPUpdateState = (state_obj) => {
        return {
        type: SET_SBTP_UPDATE_STATE,
        payload: {state_obj}
        };
};